<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active"><a href="javascript:;">Task</a></li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('task_header_name') }} <!--<small class="ml-2">{{ this.$t('task_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:user="user"
						:checkRole="checkRole"
						:washStations="washStations.washStations"
						:customers="customers.customers"
						:products="products.products"
						:workers="workers.workers"
						:tasks="tasks.tasks"
						:task="task"
						:status="status"
						:invoice="invoice"
						:getInvoice="getInvoice"
						:taskCreateCall="taskCreateCall"
						:taskEditCall="taskEditCall"
						:taskDeleteCall="taskDeleteCall"
						:taskConfirmCall="taskConfirmCall"
						:filterCustomers="filterCustomers"
						:filterProducts="filterProducts"
						:filterWorkers="filterWorkers"
						:dateFormat="dateFormat"
						:translateUnit="translateUnit"
						:findById="findById"
						:checkTaskCustomer="checkTaskCustomer"
						:calcDuration="calcDuration"
						:loadCertificatePDF="loadCertificatePDF"
						:getTasks="getTasks"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { taskService } from '../services/task.service.js'
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
    name: 'Task',
	components: {
		PageContentContainer,
	},
    props: [
		'checkRole',
		'user',
	],
	data() {
		return {
			dateFormat: 'DD.MM.YYYY HH:mm',
			dataChanged: false,
		}
	},
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
    computed: {
        ...mapState('task', ['tasks', 'task', 'status']),
        ...mapState('washStation', ['washStations']),
        ...mapState('product', ['products']),
        ...mapState('customer', ['customers', 'customer']),
        ...mapState('worker', ['workers']),
        ...mapState('invoice', ['invoice']),
    },
    methods: {
        ...mapActions('task', ['getTasks', 'getTask', 'createTask', 'editTask', 'deleteTask', 'loadCertificate']),
        ...mapActions('washStation', ['getWashStations']),
        ...mapActions('product', ['getProducts']),
		...mapActions('customer', ['getCustomers']),
        ...mapActions('worker', ['getWorkers']),
        ...mapActions('invoice', ['getInvoice']),
		async taskCreateCall(data) {
			await this.createTask(data);
            this.$router.push("/task");
			this.dataChanged = true;
        },
		async taskEditCall(taskId, taskData) {
			await this.editTask({ taskId, taskData });
            this.$router.push("/task");
			this.dataChanged = true;
		},
		async taskDeleteCall(id) {
			await this.deleteTask(id);
            this.$router.push("/task");
			this.dataChanged = true;
		},
		async taskConfirmCall(taskId, taskData) {
			await this.editTask({ taskId, taskData });
			this.dataChanged = true;
		},
		filterCustomers(customers) {
			if (customers && customers.length) {
				let fCustomers = [{
					id: 0,
					name: this.$t('task_form_option_new_customer'),
				}];
				customers.forEach(customer => {
					if (customer.isActive) {
						fCustomers.push({
							id: customer.id,
							name: customer.name,
						});
					}
				});
				return fCustomers;
			}
		},
		filterProducts(products) {
			if (products && products.length) {
				return products.filter(product => {
					return product.isActive;
				});
			}
		},
		filterWorkers(workers) {
			if (workers && workers.length) {
				return workers.filter(worker => {
					return worker.isActive;
				});
			}
		},
		translateUnit(unit) {
			switch (unit) {
				case 'NO_UNIT':
					return this.$t('task_unit_none')
				case 'PIECE':
					return this.$t('task_unit_piece')
				case 'LITER':
					return this.$t('task_unit_liter')
				default:
					return unit
			}
		},
        findById(array, id) {
			if (array && array.length) {
				return array.find(item => item.id == id);
			}
        },
        checkTaskCustomer(customers, customerId) {
            if (!customerId) {
                return this.$t('task_new_customer');
            } else {
                let customer = this.findById(customers, customerId);
                return customer ? customer.name : "-";
            }
        },
        calcDuration(startTime, endTime) {
			var difference = endTime - startTime;
            var daysDifference = Math.floor(difference/1000/60/60/24);
            difference -= daysDifference*1000*60*60*24;
            var hoursDifference = Math.floor(difference/1000/60/60);
            difference -= hoursDifference*1000*60*60;
            var minutesDifference = Math.floor(difference/1000/60);
            difference -= minutesDifference*1000*60;
            var secondsDifference = Math.floor(difference/1000);
            
            var durations = [];
            if (daysDifference) {
                durations.push(`${daysDifference} ${this.$t('task_duration_days')}`)
            }
            if (hoursDifference) {
                durations.push(`${hoursDifference} ${this.$t('task_duration_hours')}`)
            }
            if (minutesDifference) {
                durations.push(`${minutesDifference} ${this.$t('task_duration_minutes')}`)
            }
            if (secondsDifference) {
                durations.push(`${secondsDifference} ${this.$t('task_duration_seconds')}`)
            }
            let durationString = durations.join(', ');
            return durationString;
		},
		loadCertificatePDF(certData) {
			taskService.loadCertificate(certData);
		},
    },
    mounted() {
		if (!this.tasks.length) {
			this.getTasks();
		}
		if (!this.washStations.length) {
			this.getWashStations();
		}
		if (!this.customers.length) {
			this.getCustomers();
		}
		if (!this.workers.length) {
			this.getWorkers();
		}
		if (!this.products.length) {
			this.getProducts();
		}
		if (this.$route.params.id) {
			this.getTask(this.$route.params.id);
		}
	},
	watch: {
		dataChanged() {
			if (this.dataChanged) {
				this.getTasks();
				this.dataChanged = false;
			}
		},
		invoice() {
			if (!this.$route.params.id) {
				this.getTasks();
			}
		},
	},
}
</script>
